import React, { useState } from "react";
import { useAuthStore } from "../../stores/authStore";
import { useProfile } from "../../hooks/useProfile";
import { useListIdFromUrl } from "../../hooks/useListIdFromUrl";
import { isValidUrl } from "../../lib/urlUtils";
import { LinkPreviewCard } from "../linkpreview/LinkPreviewCard";

export const FloatingUrlBar: React.FC = () => {
  const status = useAuthStore((s) => s.status);
  const { data: profile } = useProfile();
  const [url, setUrl] = useState("");
  const currentListId = useListIdFromUrl();

  // Only show on items page (after onboarding is complete)
  if (status !== "authenticated" || !profile?.has_completed_onboarding) return null;

  const showPreview = isValidUrl(url);

  const handleClose = () => setUrl("");

  return (
    <>
      {showPreview && (
        <div className="ob-link-preview-container">
          <LinkPreviewCard key={url.trim()} url={url.trim()} onClose={handleClose} defaultListId={currentListId} />
        </div>
      )}
      <div className="ob-floating-bar">
        <div className="ob-floating-bar-inner">
          <input
            className="ob-floating-input"
            type="text"
            placeholder="Paste a link to something you want to remember or buy…"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            autoComplete="off"
            spellCheck="false"
          />
        </div>
      </div>
    </>
  );
};
